<template>
  <v-ons-page id="product-list-page">
    <v-ons-toolbar class="home-toolbar">
      <div class="left">
        <v-ons-back-button>
        </v-ons-back-button>
      </div>
      <div class="center">{{ type.title }}</div>
      <div class="right">
        <v-ons-toolbar-button @click="$emit('toggleMenu')">
          <i class="fa fa-sliders"></i>
        </v-ons-toolbar-button>
      </div>
    </v-ons-toolbar>

    <v-ons-list style="overflow: scroll;">

      <v-ons-list-item
        v-for="product in filteredProducts"
        modifier="longdivider"
        :key="product.Name"
        class="product-list-item">
        <div class="center" @click="push(product)">
          <div v-html="product.NameSvgString"></div>
        </div>
        <div class="right" @click="toggleFavorite(product)">
          <i v-show="product.fav" class="fa fa-star"></i>
          <i v-show="!product.fav" class="fa fa-star-o"></i>
        </div>
      </v-ons-list-item>

    </v-ons-list>

    <div
      v-show="filteredProducts.length === 0"
      class="flex-column flex-grow align-items-center justify-content-center">
      No results match your filters.
    </div>

  </v-ons-page>
</template>

<script>
import Graphic from './Graphic'
import { appData } from '../data.js'

export default {
  name: 'filters-list',
  props: {
    type: Object,
    products: Array
  },
  data () {
    return {
      menuIsOpen: false
    }
  },
  methods: {
    push(product) {
      this.$emit('push-page', {
        extends: Graphic,
        onsNavigatorProps: {
          product: product,
        }
      });
    },
    toggleFavorite(product) {
      appData.toggleFavorite(product);
    }
  },
  computed: {
    filteredProducts() {
      let productsInSliderRange;
      if(this.type.Sliders[0]) {
        let sliderLabel = this.type.Sliders[0].Label;
        productsInSliderRange = this.products.filter(p => {
          let sliderValue = p.FilterValues.filter(v => {
            return sliderLabel.includes(v.Label)
          })[0].Value;
          return parseFloat(sliderValue) >= parseFloat(this.type.selectedMin) && parseFloat(sliderValue) <= parseFloat(this.type.selectedMax);
        });
      } else {
        productsInSliderRange = this.products;
      }

      if(this.type.selectedOptions.length === 0) {
        return productsInSliderRange;
      }

      let productsInSliderRangeAndSelect = [];
      productsInSliderRange.forEach(product => {
        product.FilterValues.forEach(filterValue => {
          this.type.selectedOptions.forEach(option => {
            if(filterValue.Values && filterValue.Values.filter(v => v == option.trim())[0]) {
              if(productsInSliderRangeAndSelect.filter(p => p.Name === product.Name).length === 0) {
                productsInSliderRangeAndSelect.push(product);
              }
            } else if(filterValue.Value === option.trim()) {
              if(productsInSliderRangeAndSelect.filter(p => p.Name === product.Name).length === 0) {
                productsInSliderRangeAndSelect.push(product);
              }
            }

          });
        });
      });

      return productsInSliderRangeAndSelect;
    },
  },
  created() {

  }
}
</script>

<style scoped>
  .fa-star, .fa-star-o {
    color: #dcca72;
  }
</style>



// WEBPACK FOOTER //
// src/components/FiltersList.vue